const AiChatSuggestionPage = {
  BANKING_ALM        : 'BANKING_ALM',
  BANKING_DASHBOARD  : 'BANKING_DASHBOARD',
  BANKING_HEDGING    : 'BANKING_HEDGING',
  BANKING_RATES      : 'BANKING_RATES',
  BANKING_RISK       : 'BANKING_RISK',
  CORPORATE_ALERTS   : 'CORPORATE_ALERTS',
  CORPORATE_DASHBOARD: 'CORPORATE_DASHBOARD',
  CORPORATE_HEDGING  : 'CORPORATE_HEDGING',
  CORPORATE_INDUSTRY : 'CORPORATE_INDUSTRY',
  CORPORATE_POSITIONS: 'CORPORATE_POSITIONS',
  CORPORATE_RISK     : 'CORPORATE_RISK'
}

export default AiChatSuggestionPage
